import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Check } from 'lucide-react';
import type { AppDispatch } from '@/app/store/store';
import { paymentBuild } from '../../config/payment.build';
import { usePaymentContextSuccessResult } from '../hooks/usePaymentContextSuccessResult';

export const PayViaLinkSuccessResult: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { service } = useMemo(() => paymentBuild(dispatch), [dispatch]);
  const { hasRefreshError, paymentDate } = usePaymentContextSuccessResult({ service });

  return (
    <main className="flex flex-1 items-center justify-center bg-[#2E7E22] px-4 py-24 text-center text-white">
      <div className="flex -translate-y-6 flex-col items-center">
        <div className="relative h-20 w-20">
          <span className="absolute left-1/2 top-0 h-5 w-[3px] -translate-x-1/2 rounded-full bg-white" />
          <span className="absolute bottom-0 left-1/2 h-5 w-[3px] -translate-x-1/2 rounded-full bg-white" />
          <span className="absolute left-0 top-1/2 h-[3px] w-5 -translate-y-1/2 rounded-full bg-white" />
          <span className="absolute right-0 top-1/2 h-[3px] w-5 -translate-y-1/2 rounded-full bg-white" />
          <span className="absolute left-3 top-3 h-5 w-[3px] -rotate-45 rounded-full bg-white" />
          <span className="absolute right-3 top-3 h-5 w-[3px] rotate-45 rounded-full bg-white" />
          <span className="absolute bottom-3 left-3 h-5 w-[3px] rotate-45 rounded-full bg-white" />
          <span className="absolute bottom-3 right-3 h-5 w-[3px] -rotate-45 rounded-full bg-white" />
          <span className="absolute right-6 top-1 h-2 w-2 rotate-45 bg-[#F6F05A]" />
          <span className="absolute right-4 top-6 h-1.5 w-1.5 rotate-45 bg-[#F6F05A]" />
          <div className="absolute inset-0 flex items-center justify-center">
            <Check className="h-12 w-12 text-[#F6F05A]" strokeWidth={5} />
          </div>
        </div>

        <h1 className="mt-4 text-xl font-bold leading-tight md:text-2xl">
          Payment successful.
        </h1>
        <p className="mt-3 text-base font-medium text-white/80">
          {paymentDate}
        </p>

        {hasRefreshError && (
          <p className="mt-5 max-w-md text-sm font-semibold text-white/85">
            Payment succeeded, but transaction details could not be refreshed.
          </p>
        )}
      </div>
    </main>
  );
};

export default PayViaLinkSuccessResult;
